// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__3iAWn","clickable":"icon_clickable__1P0q-"};